"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationError = exports.ErrorCode = void 0;
exports.ErrorCode = Object.freeze({
    AUTHENTICATION: Symbol(10),
    AUTHORIZATION: Symbol(11),
    NOT_SUPPORTED: Symbol(20),
    UNEXPECTED: Symbol(21),
    SERVER_FAILED: Symbol(22),
    HTTP_NO_RESPONSE: Symbol(30),
    HTTP_ERROR_RESPONSE: Symbol(31),
    HTTP_ERROR_404_NOT_FOUND: Symbol(32),
    HTTP_BAD_REQUEST: Symbol(33),
    HTTP_FORBIDDEN: Symbol(34),
    CANCELLED: Symbol(9000),
    GENERIC: Symbol(9999),
});
var ApplicationError = /** @class */ (function () {
    /**
     *
     * @param {Symbol} code
     * @param {string} message - english error message for logs
     * @param {any} payload - any extra information
     */
    function ApplicationError(code, message, payload) {
        if (payload === void 0) { payload = null; }
        this.code = code;
        this.message = message;
        this.payload = payload;
    }
    /**
     *
     * @param {any} payload - any extra information
     */
    ApplicationError.Unexpected = function (payload) {
        if (payload === void 0) { payload = null; }
        return new ApplicationError(exports.ErrorCode.UNEXPECTED, "Unexpected error", payload);
    };
    return ApplicationError;
}());
exports.ApplicationError = ApplicationError;
//# sourceMappingURL=ApplicationError.js.map